"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.btnTypeCns = exports.btnSizeCns = exports.btnCns = void 0;
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var IconLoader_1 = require("../icon/IconLoader");
exports.btnCns = (0, classnames_1.default)('br-flex', 'br-items-center', 'br-justify-center', 'br-tracking-wide', 'br-rounded-default', 'br-border', 'br-border-solid', 'focus:br-outline-none');
exports.btnSizeCns = {
    sm: (0, classnames_1.default)('br-px-2', 'br-py-1'),
    // NOTE about px-3: this value is balanced against the icon padding. See below.
    md: (0, classnames_1.default)('br-px-5', 'br-py-2.5'),
    lg: (0, classnames_1.default)('br-px-8', 'br-py-4')
};
exports.btnTypeCns = {
    primary: (0, classnames_1.default)('br-bg-blue-600', 'br-text-white', 'br-border-blue-600', 'focus:br-shadow-blue'),
    'primary-light': (0, classnames_1.default)('br-bg-blue-100', 'br-text-blue-600', 'br-border-blue-100', 'focus:br-shadow-blue'),
    secondary: (0, classnames_1.default)('br-bg-green-400', 'br-text-white', 'br-border-green-400', 'focus:br-shadow-green'),
    warning: (0, classnames_1.default)('br-bg-red-600', 'br-text-white', 'br-border-red-600', 'focus:br-shadow-red'),
    white: (0, classnames_1.default)('br-bg-white', 'br-text-gray-800', 'br-border-white', 'focus:br-shadow-gray'),
    'primary-outline': (0, classnames_1.default)('br-bg-transparent', 'br-text-blue-600', 'br-border-blue-600', 'focus:br-shadow-blue'),
    'secondary-outline': (0, classnames_1.default)('br-bg-transparent', 'br-border-green-400', 'br-text-green-400', 'focus:br-shadow-green'),
    'warning-outline': (0, classnames_1.default)('br-bg-transparent', 'br-text-red-600', 'br-border-red-600', 'focus:br-shadow-red'),
    'gray-outline': (0, classnames_1.default)('br-bg-transparent', 'br-text-gray-800', 'br-border-gray-600', 'focus:br-shadow-gray')
};
var Button = function (_a) {
    var btnCustomCns = _a.className, loading = _a.loading, _b = _a.buttonType, buttonType = _b === void 0 ? 'primary' : _b, _c = _a.size, size = _c === void 0 ? 'md' : _c, _d = _a.iconPos, iconPos = _d === void 0 ? 'left' : _d, disabled = _a.disabled, children = _a.children, icon = _a.icon, onClick = _a.onClick, onClickDisabled = _a.onClickDisabled, unused = __rest(_a, ["className", "loading", "buttonType", "size", "iconPos", "disabled", "children", "icon", "onClick", "onClickDisabled"]);
    var currentIcon = loading ? React.createElement(IconLoader_1.IconLoader, null) : icon;
    var isInteractive = !disabled && !loading;
    return (React.createElement("button", __assign({ 
        // This is here to provide a slightly off-color version of the button when it is not interactive.
        style: { filter: isInteractive ? undefined : 'grayscale(30%)' }, 
        // When "onClickDisabled" is set, we want to keep the button interactive, else it should do nothing when disabled
        disabled: onClickDisabled ? loading : disabled || loading, className: (0, classnames_1.default)(
        // First add base button classnames
        exports.btnCns, 
        // Second mix in any user-provided custom classnames
        btnCustomCns, 
        // Third mix in the classnames for this button type
        exports.btnTypeCns[buttonType], 
        // Fourth mix in the classnames for this button size
        exports.btnSizeCns[size], {
            'br-cursor-wait': loading,
            'br-cursor-not-allowed': disabled && !loading,
            // switch
            'br-opacity-50': disabled
        }), onClick: disabled && onClickDisabled ? onClickDisabled : onClick }, unused),
        iconPos === 'left' && currentIcon && React.createElement("span", { className: (0, classnames_1.default)('br-mr-1', 'inline-block') }, currentIcon),
        React.createElement("span", { className: (0, classnames_1.default)('br-flex', 'br-flex-col', 'br-justify-center', 'br-font-bold', 'br-grow') }, children),
        iconPos === 'right' && currentIcon && React.createElement("span", { className: (0, classnames_1.default)('br-ml-1', 'inline-block') }, currentIcon)));
};
exports.Button = Button;
